module.exports = __webpack_public_path__ + "static/media/s97ga03.84144446.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/sgal/s97ga03.jpg
// module id = 268
// module chunks = 0